import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  FaArrowLeft, 
  FaCheckCircle, 
  FaCar, 
  FaUser, 
  FaTachometerAlt,
  FaTint,
  FaInfoCircle,
  FaArrowRight,
  FaExclamationTriangle,
  FaGasPump
} from 'react-icons/fa';
import { MdVerified, MdLocalGasStation } from 'react-icons/md';
import '../../styles/RegistrarAbastecimento.css';
import ConfirmacaoModal from '../../components/ConfirmacaoModal';

export default function RegistrarAbastecimentoScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Pegar parâmetros da URL
  const searchParams = new URLSearchParams(location.search);
  const solicitacaoId = searchParams.get('solicitacaoId');
  const dadosParam = searchParams.get('dados');
  
  const [solicitacao, setSolicitacao] = useState(null);
  const [litros, setLitros] = useState('');
  const [erroLitros, setErroLitros] = useState(null);
  const [showConfirmacao, setShowConfirmacao] = useState(false);

  useEffect(() => {
    if (dadosParam) {
      try {
        const parsed = JSON.parse(decodeURIComponent(dadosParam));
        setSolicitacao(parsed);
      } catch (e) {
        console.error('Erro ao parsear dados:', e);
      }
    }
  }, [dadosParam]);

  const litrosNum = parseFloat(litros.replace(',', '.'));
  const capacidadeTanque = solicitacao?.veiculo?.capacidade_tanque;
  const temCapacidade = capacidadeTanque && capacidadeTanque > 0;
  
  const podeContinuar = litros && litrosNum > 0 && (!temCapacidade || litrosNum <= capacidadeTanque);

  function validarLitros(valor) {
    let cleaned = valor.replace('.', ',');
    cleaned = cleaned.replace(/[^0-9,]/g, '');
    
    const parts = cleaned.split(',');
    if (parts.length > 2) {
      cleaned = parts[0] + ',' + parts.slice(1).join('');
    }

    const [inteiro, decimal] = cleaned.split(',');
    if (decimal !== undefined) {
      cleaned = `${inteiro},${decimal.slice(0, 3)}`;
    }
    
    setLitros(cleaned);
    const num = parseFloat(cleaned.replace(',', '.'));
    
    if (!cleaned || isNaN(num)) {
      setErroLitros(null);
      return;
    }
    
    if (num <= 0) {
      setErroLitros('Informe uma quantidade maior que zero');
      return;
    }
    
    if (temCapacidade && num > capacidadeTanque) {
      setErroLitros(`Quantidade excede a capacidade do tanque (${capacidadeTanque} L)`);
      return;
    }
    
    setErroLitros(null);
  }

  function handleContinuar() {
    if (!podeContinuar || !solicitacao) return;
    setShowConfirmacao(true);
  }

  function handleConfirmarAbastecimento() {
    setShowConfirmacao(false);
  
    if (temCapacidade && litrosNum > capacidadeTanque) {
      const confirmado = window.confirm(
        `A quantidade informada (${litrosNum} L) excede a capacidade do tanque (${capacidadeTanque} L).\n\nDeseja continuar mesmo assim?`
      );
  
      if (confirmado) {
        navegarParaProcessamento();
      }
      return;
    }
  
    navegarParaProcessamento();
  }
  
  function handleCancelarConfirmacao() {
    setShowConfirmacao(false);
  }
  
  function navegarParaProcessamento() {
    // Ir direto para processamento
    const litrosParaApi = litros.replace(',', '.');
    navigate(`/processando?solicitacaoId=${solicitacao.id}&litros=${litrosParaApi}&dados=${encodeURIComponent(JSON.stringify(solicitacao))}`);
  }
  
  function handleVoltar() {
    navigate('/');
  }

  const showCapacidadeWarning = temCapacidade && litrosNum > capacidadeTanque && litrosNum > 0;

  return (
    <div className="registrar-web">
      <div className="registrar-card">
        <div className="registrar-header-web">
          <button className="back-btn-web" onClick={handleVoltar}>
            <FaArrowLeft />
            <span>Voltar</span>
          </button>
          <h1 className="header-title-web">
            <FaGasPump className="header-icon" />
            Registrar Abastecimento
          </h1>
        </div>

        <div className="success-banner-web">
          <MdVerified className="success-icon-web" />
          <div className="success-content-web">
            <h4>Posto validado com sucesso</h4>
            <p>Ativo · Credenciado · Localização confirmada</p>
          </div>
        </div>

        {/* Info do veículo */}
        <div className="info-card-web">
          <div className="card-header-web">
            <FaCar className="card-icon-web" />
            <h3>Informações do Veículo</h3>
          </div>
          
          <div className="info-grid-web">
            <div className="info-item-web">
              <span className="info-label-web">Placa</span>
              <span className="info-value-web">{solicitacao?.veiculo?.placa || '-'}</span>
            </div>
            <div className="info-item-web">
              <span className="info-label-web">Veículo</span>
              <span className="info-value-web" title={solicitacao?.veiculo?.descricao}>
                {solicitacao?.veiculo?.descricao || '-'}
              </span>
            </div>
          </div>
          
          <div className="info-grid-web">
            {/*
            <div className="info-item-web">
              <span className="info-label-web">
                <FaUser className="inline-icon" />
                Motorista
              </span>
              <span className="info-value-web">{solicitacao?.motorista?.nome || '-'}</span>
            </div>
            <div className="info-item-web">
              <span className="info-label-web">
                <FaTachometerAlt className="inline-icon" />
                KM Atual
              </span>
              <span className="info-value-web">{solicitacao?.km || '-'}</span>
            </div>
            */}
          </div>
        </div>

        {/* Total de Litros */}
        <div className="litros-section-web">
          <label className="secao-label-web">
            <FaTint className="label-icon" />
            Total de Litros
          </label>
          
          <div className={`litros-input-wrapper-web ${litros ? 'active' : ''} ${erroLitros ? 'error' : ''}`}>
            <input
              type="text"
              className="litros-input-web"
              value={litros}
              onChange={(e) => validarLitros(e.target.value)}
              placeholder="0,000"
              inputMode="decimal"
              autoFocus
            />
            <span className="litros-unidade-web">Litros</span>
          </div>
          
          {erroLitros ? (
            <div className="error-message-web">
              <FaExclamationTriangle />
              <span>{erroLitros}</span>
            </div>
          ) : showCapacidadeWarning ? (
            <div className="warning-message-web">
              <FaExclamationTriangle />
              <span>Quantidade excede a capacidade do tanque ({capacidadeTanque} L)</span>
            </div>
          ) : (
            <div className="hint-message-web">
              <FaInfoCircle />
              <span>
                {temCapacidade 
                  ? `Capacidade do tanque: ${capacidadeTanque} L` 
                  : 'Informe o total de litros abastecidos conforme o visor da bomba'}
              </span>
            </div>
          )}
        </div>

        {/* Resumo do abastecimento 
        {litrosNum > 0 && !erroLitros && (
          <div className="resumo-web">
            <h4>Resumo do Abastecimento</h4>
            <div className="resumo-item">
              <span>Quantidade:</span>
              <strong>{litrosNum.toFixed(3).replace('.', ',')} Litros</strong>
            </div>
            <div className="resumo-item">
              <span>Veículo:</span>
              <strong>{solicitacao?.veiculo?.placa || '-'}</strong>
            </div>
            <div className="resumo-item">
              <span>Posto:</span>
              <strong>{solicitacao?.posto_nome || 'Posto validado'}</strong>
            </div>
          </div>
        )}*/}

        <button
          className={`btn-continuar-web ${!podeContinuar ? 'disabled' : ''}`}
          disabled={!podeContinuar}
          onClick={handleContinuar}
        >
          <span>Continuar</span>
          <FaArrowRight />
        </button>
      </div>
      <ConfirmacaoModal
        show={showConfirmacao}
        onClose={handleCancelarConfirmacao}
        onConfirm={handleConfirmarAbastecimento}
        litros={litros}
        placa={solicitacao?.veiculo?.placa}
        veiculo={solicitacao?.veiculo?.descricao}
      />
    </div>
  );
}